<template>
  <transition name="modal">
    <div class="modal is-active" v-if="isOpen">
      <div class="modal-background" @click="handleClose"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <div></div>
          <button class="close" aria-label="close" @click="handleClose"></button>
        </header>
        <section class="modal-card-body center-content">
          <slot name="body" />
        </section>
        <hr />
        <footer class="modal-card-foot">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'WAlertModal',
    emits: ['close'],
    props: {
      isOpen: Boolean,
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
    },
  };
</script>
